<template>
  <div class="consulting">
    <div class="topLi">
      <span :class="['default',showNow?'active':'']" @click="toggle(true)">咨询</span>
      <span :class="['default',!showNow?'active':'']" @click="toggle(false)">投诉</span>
    </div>
    <div class="main" v-show="showNow">
      <div v-for="(item,index) in consultationList" :key="index">
        <div class="showConent" v-if="item.methodName === 'consultationHotline'">
          <!-- <a-icon class="iconStyle" :component="phoneIcon"></a-icon> -->
          <img src="../mobile.png" class="iconStylemobile" alt=""/>
          <span>
            {{ item.methodDesc }}
          </span>
        </div>
        <div class="showConent" v-if="item.methodName === 'consultationUrl'">
          <!-- <a-icon class="iconStyle" :component="messageIcon"></a-icon> -->
          <img src="../message.png" class="iconStylemessage" alt=""/>
          <span><a @click="togo(item.methodDesc)"> 前往咨询</a></span>
        </div>
        <div class="showConent" v-if="item.methodName === 'consultationAddress'">
          <!-- <a-icon class="iconStyle" :component="locationIcon"></a-icon> -->
          <span class="icon">
            <img src="../place.png" class="iconStyleplace" alt=""/>
          </span>
          <span>
            {{ item.methodDesc }}
          </span>
        </div>
      </div>
    </div>
    <div class="main" v-show="!showNow">
      <div v-for="(item,index) in complaintsList" :key="index">
        <div class="showConent" v-if="item.methodName === 'complaintHotline'">
          <!-- <a-icon class="iconStyle" :component="phoneIcon"></a-icon> -->
          <img src="../mobile.png" class="iconStylemobile" alt=""/>
          <span>
            {{ item.methodDesc }}
          </span>
        </div>
        <div class="showConent" v-if="item.methodName === 'complaintUrl'">
          <!-- <a-icon class="iconStyle" :component="messageIcon"></a-icon> -->
          <img src="../message.png" class="iconStylemessage" alt=""/>
          <span><a @click="togoComplaint(item.methodDesc)"> 前往投诉</a></span>
        </div>
        <div class="showConent" v-if="item.methodName === 'complaintAddress'">
          <!-- <a-icon class="iconStyle" :component="locationIcon"></a-icon> -->
          <span class="icon">
            <img src="../place.png" class="iconStyleplace" alt=""/>
          </span>
          <span>
            {{ item.methodDesc }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import locationIcon from '@/assets/jiopweb3.0.0/locationIcon.svg?inline'
import phoneIcon from '@/assets/jiopweb3.0.0/phoneIcon.svg?inline'
import messageIcon from '@/assets/jiopweb3.0.0/dingdong.svg?inline'
export default {
  props: {
    consultationList: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => []
    },
    complaintsList: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => []
    },
    consultOption: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => []
    },
    complaintOption: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => []
    }
  },
  components: {

  },
  computed: {
  },
  data () {
    return {
      locationIcon,
      phoneIcon,
      messageIcon,
      showNow: true
    }
  },
  methods: {
    toggle (value) {
      this.showNow = value
    },
    togo (url) {
      window.open(url)
    },
    togoComplaint (url) {
      window.open(url)
    }
  }
}
</script>

<style lang="less" scoped>
.consulting {
  .topLi {
    .default {
      font-size: 22px;
      color: #333333;
      margin-right: 25px;
      padding-bottom: 12px;
      cursor: pointer;
    }
    .active {
      color: #1777ff;
      background: url('~@/assets/jiopweb3.0.0/lunboSelect.png') no-repeat bottom center;
      background-size: 50% 15%;
    }
  }
  .main {
    border: 1px solid rgba(238, 238, 238, 1);
    padding: 30px;
    margin-top: 20px;
    .showConent {
      // height: 35px;
      line-height: 30px;
      display: flex;
      align-items: flex-start;
      .icon{
        width: 30px;
      }
      .iconStyleplace {
        margin-top: 8px;
        // font-size: 16px;
        width: 18px;
        height: 14px;
      }
      .iconStylemobile {
        margin-top: 8px;
        // font-size: 16px;
        width: 13px;
        height: 14px;
        margin-right: -3px;
      }
      .iconStylemessage {
        margin-top: 8px;
        // font-size: 16px;
        width: 13px;
        height: 14px;
      }
      span {
        margin-left: 10px;
      }
    }
  }
}
</style>
